import React, { useState, useEffect } from "react";
import RouterWrapper from "./Routers";
import "./App.css";
import ScrollToTop from "./Components/ScrollToTop";
import Loader from "./Components/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./utils/AuthContext";

const App = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Show loader on route change
    setLoading(true);

    // Smooth transition: wait a bit for the page to feel "loaded"
    const timer = setTimeout(() => {
      setLoading(false);
    }, 600); // 600ms is enough for a nice animation feel

    return () => clearTimeout(timer);
  }, [location.pathname]);

  // Admin panel shortcut: Ctrl+Shift+A (Windows/Linux) or Cmd+Shift+A (Mac)
  useEffect(() => {
    const handleAdminShortcut = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key.toLowerCase() === 'a') {
        e.preventDefault();
        const adminToken = localStorage.getItem('adminToken');
        if (adminToken) {
          navigate('/admin/reviews');
        } else {
          navigate('/admin/login');
        }
      }
    };

    window.addEventListener('keydown', handleAdminShortcut);
    return () => window.removeEventListener('keydown', handleAdminShortcut);
  }, [navigate]);

  return (
    <HelmetProvider>
      <AuthProvider>
        <div className="App">
          <ScrollToTop />
          <AnimatePresence mode="wait">
            {loading && <Loader key="loader" />}
          </AnimatePresence>
          <RouterWrapper />
        </div>
      </AuthProvider>
    </HelmetProvider>
  );
};

export default App;

